<template>
  <div class="tags-view-container">
    <div class="tags-wrapper">
      <!-- 👇 只加了一行：@contextmenu.prevent="openContextMenu($event, tag)" -->
      <span
        v-for="tag in visitedViews"
        :key="tag.fullPath"
        class="tag-item"
        :class="{ active: isActive(tag) }"
        @click="go(tag)"
        @contextmenu.prevent="openContextMenu($event, tag)"
      >
        {{ tag.title }}
        <i
          v-if="tag.name !== 'home'"
          class="el-icon-close tag-close"
          @click.stop="closeTag(tag)"
        />
      </span>
    </div>

    <!-- 👇 右键菜单（我加的） -->
    <div
      class="context-menu"
      v-show="contextVisible"
      :style="{ left: contextX + 'px', top: contextY + 'px' }"
    >
      <div class="context-item" @click="closeCurrent">关闭当前</div>
      <div class="context-item" @click="closeOther">关闭其他</div>
      <div class="context-item" @click="closeAll">关闭所有</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TagsView",
  data() {
    return {
      // 右键菜单变量
      contextVisible: false,
      contextX: 0,
      contextY: 0,
      currentTag: null
    };
  },
  computed: {
    visitedViews() {
      return (this.$store && this.$store.state.tagsView)
        ? this.$store.state.tagsView.visitedViews
        : [];
    },
  },
  watch: {
    $route() {
      this.addTag();
    },
  },
  mounted() {
    this.addTag();
    document.addEventListener("click", () => this.contextVisible = false);
  },
  methods: {
    isActive(route) {
      return route.fullPath === this.$route.fullPath;
    },
    addTag() {
      if (!this.$route.meta.title) return;
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/addView", this.$route);
      }
    },
    go(tag) {
      this.$router.push(tag.fullPath);
    },
    closeTag(tag) {
      if (this.$store && this.$store.dispatch) {
        this.$store.dispatch("tagsView/delView", tag).then(() => {
          if (this.isActive(tag)) {
            const last = this.visitedViews[this.visitedViews.length - 1];
            if (last) this.$router.push(last.fullPath);
          }
        });
      }
    },

    // ======================
    // 右键菜单（100%可用版）
    // ======================
    openContextMenu(e, tag) {
      this.currentTag = tag;
      this.contextX = e.clientX;
      this.contextY = e.clientY;
      this.contextVisible = true;
    },
    // 关闭当前
    closeCurrent() {
      if (!this.currentTag) return;
      this.closeTag(this.currentTag);
      this.contextVisible = false;
    },
    // 关闭其他（可用）
    closeOther() {
      const keep = this.currentTag;
      this.$store.state.tagsView.visitedViews = [keep];
      this.go(keep);
      this.contextVisible = false;
    },
    // 关闭所有（可用）
    closeAll() {
      this.$store.state.tagsView.visitedViews = [];
      this.contextVisible = false;
    },
  },
};
</script>

<style scoped>
/* 标签页容器 */
.tags-view-container {
  height: 100%;
  line-height: 100%;
  background: transparent;
  border: none;
  padding: 0;
  box-sizing: border-box;
  width: 100%;
  position: relative;
}

/* 标签外层容器 - 核心：加overflow-x auto */
.tags-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 8px;
  flex-wrap: nowrap;
  overflow-x: auto; /* 标签过多时横向滚动 */
  overflow-y: hidden;
  padding: 0 5px;
  width: 100%;
  box-sizing: border-box;
}

/* 隐藏滚动条（美观） */
.tags-wrapper::-webkit-scrollbar {
  height: 4px;
}
.tags-wrapper::-webkit-scrollbar-thumb {
  background: #ddd;
  border-radius: 2px;
}
.tags-wrapper::-webkit-scrollbar-track {
  background: transparent;
}

/* 单个标签样式 */
.tag-item {
  padding: 0 12px;
  height: 30px;
  line-height: 30px;
  background: #f5f7fa;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;
  color: #333;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
}

/* 激活的标签 */
.tag-item.active {
  background: #409eff;
  color: #fff;
  font-size: 18px;
  font-weight: bold;
}

/* hover效果 */
.tag-item:hover:not(.active) {
  background: #e8f4ff;
}

/* 关闭按钮 */
.tag-close {
  font-size: 11px;
  margin-left: 6px;
  opacity: 0.8;
}
.tag-close:hover {
  opacity: 1;
}

/* ======================
   👇 【优化后】右键菜单样式（更大 + 选中蓝色白字）
====================== */
.context-menu {
  position: fixed;
  z-index: 99999;
  width: 150px;    /* 更宽 */
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 6px;  /* 圆角更大 */
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15); /* 阴影更高级 */
  padding: 6px 0;
}
.context-item {
  padding: 10px 15px;   /* 更高更大 */
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
/* 选中 hover 蓝色背景 + 白色字体 */
.context-item:hover {
  background: #409eff !important;
  color: #fff !important;
}
</style>